module.exports = "/next-static/_next/static/images/block_image_one-aa288406932714a64198033426ae7031.png";